var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    class: {
      "has-logo": _vm.showLogo
    }
  }, [_vm.showLogo ? _c("logo", {
    attrs: {
      collapse: _vm.isCollapse
    }
  }) : _vm._e(), _c("div", {
    staticClass: "sidebar-menu-wrap scrollbar-wrapper"
  }, [_c("nav", {
    staticClass: "sidebar-nav"
  }, _vm._l(_vm.sidebarRoutes, function (route) {
    return _c("sidebar-item", {
      key: route.name || route.path,
      attrs: {
        item: route,
        "base-path": route._sidebarParentPath != null ? route._sidebarParentPath : route.path
      }
    });
  }), 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };